<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/state';

  import Routes from '$provider/constants/Route';
  import UIDisclaimer from '$provider/constants/UIDisclaimer';
  import AttachmentWarnAlert from './AttachmentWarnAlert.svelte';

  interface Props {
    noAction?: boolean;
    simple?: boolean;
  }

  let { noAction = false, simple = false }: Props = $props();

  let providerId = $derived(page.params.provider || page.params.providerId);
  let showSimpleText = $derived(simple || !providerId);

  const onClickDocument = (): void => {
    goto(Routes.ProviderDetailFile.replace('%providerId%', providerId));
  };
</script>

<AttachmentWarnAlert>
  {#if showSimpleText}
    {UIDisclaimer.LicenseAttachmentUnableDownload}
  {:else}
    {UIDisclaimer.LicenseAttachmentUnableDownload} and upload it to this provider's {#if !noAction}<a
        class="link-highlight"
        href="/"
        onclick={(e) => { e.preventDefault(); onClickDocument(); }}
      >
        documents
      </a>{:else}documents{/if}
  {/if}
</AttachmentWarnAlert>

<style>
  .link-highlight {
    color: var(--blue);
    text-decoration: none;
  }
</style>
